import * as mutations from "../../graphql/mutations";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../helpers/apiClient";
import {
  Box,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { fetchAssessmentById } from "../../helpers/apiRequests";

export default function NewModuleModal({
  dataLabel,
  open,
  setOpen,
  module,
  assessmentId,
  setNotificationMessage,
  setOpenNotification,
  fetchAssessmentData,
}) {
  const emptyModule = {
    id: "",
    sortingNumber: 0,
    title: "",
  };

  const { t } = useTranslation();
  const [newModule, setNewModule] = useState(module);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    maxWidth: 0.95,
    minWidth: 500,
    borderRadius: 5,
    boxShadow: 24,
    p: 2,
  };

  function resetData() {
    setNewModule(emptyModule);
  }

  async function addModule() {
    try {
      const assessment = await fetchAssessmentById(assessmentId);
      await apiClient.graphql({
        query: mutations.createModule,
        variables: {
          input: {
            sortingNumber: parseInt(newModule.sortingNumber),
            title: newModule.title,
            assessmentID: assessmentId,
            ownerGroups: assessment.ownerGroups,
          },
        },
      });
      setNotificationMessage(`${dataLabel} ${t("added")}`);
    } catch (e) {
      console.error(e);
      setNotificationMessage(t("errorMessage"));
    }
    fetchAssessmentData();
    setOpenNotification(true);
    setOpen(false);
  }

  async function changeModule() {
    try {
      await apiClient.graphql({
        query: mutations.updateModule,
        variables: {
          input: {
            id: newModule.id,
            sortingNumber: parseInt(newModule.sortingNumber),
            title: newModule.title,
          },
        },
      });
      setNotificationMessage(`${dataLabel} ${t("added")}`);
    } catch (e) {
      setNotificationMessage(t("errorMessage"));
    }
    fetchAssessmentData();
    setOpenNotification(true);
    setOpen(false);
  }

  function handleNewModuleChange(event, key) {
    setNewModule({
      ...newModule,
      [key]: event.target.value,
    });
  }

  useEffect(() => {
    if (open) {
      setNewModule(module);
    } else {
      resetData();
    }
  }, [open]);

  return (
    <div>
      <Modal open={open} disableAutoFocus={true}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: 17 }}>
                {module.id === "" ? t("createModule") : t("updateModule")}
              </Typography>
              <IconButton
                onClick={() => {
                  setNewModule(emptyModule);
                  setOpen(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ my: 1 }} />
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: 120, ml: 2, mt: 3 }}
              label={"Sorting Number"}
              type="number"
              variant="outlined"
              size="small"
              value={newModule.sortingNumber}
              onChange={(event) =>
                handleNewModuleChange(event, "sortingNumber")
              }
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={"Title"}
              variant="outlined"
              size="small"
              sx={{ width: 300, mt: 3, ml: 2 }}
              value={newModule.title}
              onChange={(event) => handleNewModuleChange(event, "title")}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              sx={{ mt: 0.5 }}
              onClick={() => {
                if (module.id === "") {
                  addModule();
                } else {
                  changeModule();
                }
              }}
            >
              <CheckIcon />
            </IconButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
